import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });
const url = `${baseURL}/v1/levels`;

export interface Level {
  id?: string;
  number: number;
  /** The small line over the name on the result screen */
  heading?: string;
  name?: string;
  /** The total score where this level starts */
  minScore: number;
  imageUrl?: string;
}

export const getLevels = async (): Promise<Level[]> => {
  try {
    const response = await axios.get(url, headers());
    return response.data?.results || [];
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke hente levels", false);
    return [];
  }
};

export const saveLevel = async (level: Level): Promise<Level | null> => {
  try {
    const body = { number: Number(level.number), heading: level.heading || "", name: level.name || "", minScore: Number(level.minScore), imageUrl: level.imageUrl || "" };
    const response = level.id ? await axios.put(`${url}/${level.id}`, body, headers()) : await axios.post(url, body, headers());
    return response.data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke gemme level", false);
    return null;
  }
};

export const deleteLevel = async (id: string): Promise<boolean> => {
  try {
    await axios.delete(`${url}/${id}`, headers());
    return true;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke slette level", false);
    return false;
  }
};

/** Puts the default ladder in place; the levels that are already there are left alone */
export const fillDefaultLadder = async (): Promise<{ added: number; renamed?: number; pictures?: number; total: number } | null> => {
  try {
    const response = await axios.post(`${url}/default-ladder`, {}, headers());
    return response.data;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke oprette stigen", false);
    return null;
  }
};

/** The level's picture. Returns the address it was stored at. */
export const uploadLevelImage = async (file: File): Promise<string | null> => {
  try {
    const form = new FormData();
    form.append("picture", file);
    const response = await axios.post(`${url}/image`, form, {
      headers: { ...headers().headers, "Content-Type": "multipart/form-data" },
    });
    return response.data?.url || null;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Billedet kunne ikke uploades", false);
    return null;
  }
};
